var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4115 24.7032C18.2658 23.8489 19.6509 23.8489 20.5051 24.7032L36.4583 40.6564L52.4115 24.7032C53.2658 23.8489 54.6509 23.8489 55.5051 24.7032C56.3594 25.5575 56.3594 26.9425 55.5051 27.7968L38.0051 45.2968C37.1509 46.1511 35.7658 46.1511 34.9115 45.2968L17.4115 27.7968C16.5573 26.9425 16.5573 25.5575 17.4115 24.7032Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownCircleOutline);
export default __webpack_public_path__ + "static/media/down-circle-outline.70994f97b205a654f549f147fd9be4a2.svg";
export { ForwardRef as ReactComponent };